"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DATA_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _Category.DATA_MANAGEMENT;
  }
});
Object.defineProperty(exports, "HELP_DESK", {
  enumerable: true,
  get: function get() {
    return _Category.HELP_DESK;
  }
});
Object.defineProperty(exports, "KNOWLEDGE_BASE", {
  enumerable: true,
  get: function get() {
    return _Category.KNOWLEDGE_BASE;
  }
});
Object.defineProperty(exports, "LIVE_CHAT", {
  enumerable: true,
  get: function get() {
    return _Category.LIVE_CHAT;
  }
});
Object.defineProperty(exports, "SURVEY", {
  enumerable: true,
  get: function get() {
    return _Category.SURVEY;
  }
});
Object.defineProperty(exports, "TICKETING", {
  enumerable: true,
  get: function get() {
    return _Category.TICKETING;
  }
});

var _Category = require("../Category");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/superCategoryGroups/CustomerSuccess.js
// module id = 591
// module chunks = 209 210 211 212 213